import { locationProvider } from '../locationProvider.ts';

/**
 * Gets all query params as an object.
 * @param search The search string to use. Defaults to the one provided by locationProvider
 */
export function getQueryParams(search?: string): Record<string, string | boolean> {
  search ??= locationProvider.search;

  return search.length
    ? search.slice(1)
      .split(/&/g)
      .map(v => v.split(/=/))
      .reduce(
        (obj, [key, value]) =>
          // if value is undefined, it means it's a boolean parameter, so we'll just put true
          Object.assign(obj, { [key]: value ?? true }),
        {}
      )
    : {}
}